const { find } = require('lodash');

class PastShopService {
    constructor($q, $location, restangular, restangularV3, bootstrap, listProductService) {
        this.api = restangular.one('pastshops');
        this.apiV3 = restangularV3.one('pastshops');
        this.$q = $q;
        this.$location = $location;
        this.listProductService = listProductService;
        this.pastShops = [];

        // Promise used to cache past shops
        this.pastShopPromise = null;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.PastShops)) {
            this.pastShopPromise = this.$q.when(this.setPastShops(bootstrap.getBootstrappedData(bootstrap.bootstrapped.PastShops)));
        }
    }

    setPastShops(data) {
        this.pastShops = data.Response;
        return this.pastShops;
    }

    invalidateCache() {
        // This will reset the past shops promise to fetch from the API. This is needed when the
        // result is unpredictable / impractial to determine using the frontend only.
        this.pastShopPromise = null;
        return this.listPastShops();
    }

    listPastShops() {
        if (!this.pastShopPromise) {
            // Cache has been invalidated, fetch from API
            this.pastShopPromise = this.api.one('list').get().then(data => this.setPastShops(data));
        }
        return this.pastShopPromise;
    }

    getOrder(orderId) {
        return this.listPastShops().then(pastShops => this.$q.when(find(pastShops, pastShop => pastShop.OrderId === orderId)));
    }

    getProducts(orderId, pageSize, pageNumber, sortType, filters) {
        return this.api.post(orderId === 'everything' ? 'AllProducts' : `${orderId}/Products`, {
            PageSize: pageSize || 10,
            PageNumber: pageNumber,
            SortType: sortType,
            Location: this.$location.url(),
            Filters: filters ? filters.filters : [],
        });
    }

    getPastShopProductCount() {
        return this.apiV3.post('AllProductsCount');
    }

    getAllProducts(pageSize, pageNumber, sortType, filters, includeOnline, includeInstore) {
        return this.apiV3.post('AllProducts', {
            PageSize: pageSize || 10,
            PageNumber: pageNumber,
            SortType: sortType,
            Location: this.$location.url(),
            Filters: filters ? filters.filters : [],
            IncludeOnline: includeOnline,
            IncludeInstore: includeInstore,
        });
    }
}

PastShopService.$inject = ['$q', '$location', 'Restangular', 'RestangularV3', 'BootstrapService', 'ListProductService'];

module.exports = PastShopService;



// WEBPACK FOOTER //
// ./src/common/pastshops/pastshop.service.js